import React, { useMemo } from 'react';
import { ViewBox, findViewById } from '../../../core/assistant';
import { PROCESS_VIEW_GROUPS, useProcessViewState } from './ProcessRecipes';

interface ProcessViewBoxProps {
  /** Opens the Views gallery / View & Display surface. */
  onChangeView: () => void;
  /** Opens rule authoring; omit to hide the Edit button. */
  onEdit?: () => void;
  /** Render the neutral "All steps" fallback when no named view is active. */
  showDefault?: boolean;
}

/**
 * ProcessViewBox — the shared View Box hero for process maps. Shows the
 * active composite view (deep-linked via ?review=) in plain language with a
 * one-tap "Change view"; falls back to a neutral "All steps" state. Same hero
 * the Compass explorer, org chart, and genogram use.
 */
export const ProcessViewBox: React.FC<ProcessViewBoxProps> = ({
  onChangeView,
  onEdit,
  showDefault = true,
}) => {
  const { activeRecipeId } = useProcessViewState();
  const activeView = useMemo(
    () => findViewById(PROCESS_VIEW_GROUPS, activeRecipeId),
    [activeRecipeId],
  );

  if (!showDefault && !activeView) return null;

  return (
    <ViewBox
      activeView={activeView}
      onChangeView={onChangeView}
      onEdit={onEdit}
      defaultTitle="All steps"
      defaultDescription="The full process, nothing highlighted. Pick a view to focus your work."
    />
  );
};
